import React from 'react';
import Richtext from '../global/richtext/Richtext';
import styles from './legal.module.scss';
import LegalComponentModel from '../../models/legal';

type Props = {
  data: LegalComponentModel;
};

const LegalLayout = ({ data }: Props) => {
  if (!data) return <></>;

  return (
    <div className={styles.legal}>
      <div className="container">
        <div className={styles.legal__wrapper}>
          {data.content && <Richtext data={data.content} />}
        </div>
      </div>
    </div>
  );
};

export default LegalLayout;
